import { render, staticRenderFns } from "./ItemsColumn.vue?vue&type=template&id=6adf8934&scoped=true&"
import script from "./ItemsColumn.vue?vue&type=script&lang=js&"
export * from "./ItemsColumn.vue?vue&type=script&lang=js&"
import style0 from "./ItemsColumn.vue?vue&type=style&index=0&id=6adf8934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf8934",
  null
  
)

export default component.exports